import styles from "./label.module.css";

const Label = ({ className = "", name, label, required }) => {
  if (!label) return null;

  return (
    <label htmlFor={name} className={`${styles.label} ${className}`}>
      {label}
      {required && <span className={styles.required}>*</span>}
      {/* tooltip we can add later as per req */}
    </label>
  );
};

export default Label;
